const priorityColors = {
  success: {
    50: "#F0FDF4",
    100: "#DCFCE7",
    200: "#BBF7D0",
    300: "#86EFAC",
    400: "#4ADE80",
    500: "#22C55E",
    600: "#22C55E",
    700: "#15803D",
    800: "#166534",
    900: "#14532D",
  },

  info: {
    50: "#f0f9ff",
    100: "#e0f2fe",
    200: "#bae6fd",
    300: "#7dd3fc",
    400: "#38bdf8",
    500: "#0ea5e9",
    600: "#0284c7",
    700: "#0369a1",
    800: "#075985",
    900: "#0c4a6e",
  },

  warning: {
    50: "#FEFCE8",
    100: "#FEF9C3",
    200: "#FEF08a",
    300: "#FDE047",
    400: "#FACC15",
    500: "#EAB308",
    600: "#CA8A04",
    700: "#A16207",
    800: "#854D0E",
    900: "#713F12",
  },

  error: {
    50: "#FEF2F2",
    100: "#FEE2E2",
    200: "#FECACA",
    300: "#FCA5A5",
    400: "#F87171",
    500: "#EF4444",
    600: "#DC2626",
    700: "#B91C1C",
    800: "#991B1B",
    900: "#7F1D1D",
  },

  ClienteNovo: {
    600: "#01C4A0",
    700: "#01967A",
  },

  ClienteReconquista: {
    600: "#F95106",
    700: "#D94305",
  },

  PotencialOuro: {
    600: "#B8914C",
    700: "#977640",
  },
};

export default priorityColors;
